import Utility from "./Utility";

/**
 * Make types available in JSDocs without importing them since this is not a TS file.
 *
 * @import { UserType } from "../form_features";
 */

export default class UserTypeStorage {
    
    /**
     * @returns {UserType}
     */
    static getUserType() {
        const userType = Utility.getCookie('currentUserType');
        return userType;
    }

    /**
     * @param {UserType} userType
     */
    static setUserType(userType) {
        Utility.setCookie('currentUserType', userType, 90);
    }
}
